import React, { FC, useEffect, useState } from 'react'
import * as S from './styles'

export const StepperInput: FC<any> = ({ min = 0, max = 100, step = 1, onInput, defaultVal = 0 }) => {
  const [value, setValue] = useState(defaultVal)

  const handleDecrease = (e) => {
    setValue((prev) => Math.max(min, prev - step))
  }

  const handleIncrease = (e) => {
    setValue((prev) => Math.min(max, prev + step))
  }

  const handleChange = (e) => {
    const newValue = Number(e.target.value)
    if (!isNaN(newValue)) {
      setValue(Math.min(max, Math.max(min, newValue)))
    }
  }

  useEffect(() => {
    onInput(value)
  }, [value])

  return (
    <S.StepperWrapper>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <button onClick={handleDecrease}>-</button>
        <input
          type='number'
          value={value}
          className={value !== 0 ? 'activated' : ''}
          onChange={handleChange}
          style={{ width: '60px', textAlign: 'center' }}
        />
        <button onClick={handleIncrease}>+</button>
      </div>
    </S.StepperWrapper>
  )
}
